module.exports = __webpack_public_path__ + "img/logo-dbd-tech-white.340775dd.svg";